import React, { useState, useEffect } from "react";
// styles
import "../pages.css";
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import TransitionModal from "../../components/utils/modals/Modals";
import Buttons from '../../components/utils/buttonsContainer/Buttons';
// consts
import { condicionesAFIP as titles } from "../../consts/titulos-de-tablas";
import { modalsInfoCondicionesAFIP as infoModal } from "../../consts/Modals-info";
//Assets
import CircularIndeterminate from '../../components/utils/spinner/Spinner';
//Services 
import { retrieveData } from '../../services/Local-services';
import { condicionesAFIPGet } from "../../services/hooli-services/CondicionesAFIP/CondicionesAFIPGet";
// recoil
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { userCredentials, rowSelected, formData } from '../../recoilState/GlobalState';

export default function CondicionesAFIP() {
    const [condiciones, setCondiciones] = useState([]);
    const [rows, setRows] = useState([]);
    const [action, setAction] = useState({});
    const [cargando, setCargando] = useState(true);

    const [{ status }, setRow] = useRecoilState(rowSelected);
    const setFormInfo = useSetRecoilState(formData);
    const credentials = useRecoilValue(userCredentials);

    const updateList = async () => {
        setCargando(true);
        await retrieveData(credentials, setRows, condicionesAFIPGet, setCondiciones);
        setCargando(false);
    };

    useEffect(() => {
        if (Object.keys(credentials).length > 0) updateList()
    }, [credentials]);

    useEffect(() => {
        condiciones.map((item) => {
            const {
                condicionAFIPId,
                condicionAFIPCod,
                condicionAFIPNombre,
                condicionAFIPNombreAFIP
            } = item

            const condicionAFIP = {
                id: condicionAFIPId,
                [titles[0]]: condicionAFIPNombre,
                [titles[1]]: condicionAFIPCod,
                [titles[2]]: condicionAFIPNombreAFIP,
            }

            setRows(rows => [...rows, condicionAFIP])
            return item
        });
    }, [condiciones]);

    useEffect(() => setRow({ status: false }), [])

    const handleClick = ({ action, procede }) => {
        setFormInfo(infoModal[action]);
        setAction({ action, procede });
    };

    return (
        <main className="container">
            <TransitionModal
                titles={titles}
                procede={action.procede}
                updateList={updateList}
            />
            <Buttons texto="condición" handleClick={handleClick} updateList={updateList} />
            <div className="row-grid" >
                {cargando ? <CircularIndeterminate /> : <XGridDemo rows={rows} titles={titles} />}
            </div>
        </main>
    )
};